import { useTheme } from '@mui/material';
import dayjs from 'dayjs';

import {
  Icons,
  mergeSx,
  SxProps,
  withProps,
  Tooltip,
  TooltipProps,
  Stack,
  tokens,
} from '@cast/design-system';

const Value = withProps(Stack, {
  direction: 'row',
  px: 8,
  ml: 24,
  gap: 6,
  height: 28,
  borderRadius: '4px',
  color: 'grey.500',
  alignItems: 'center',
  bgcolor: 'grey.50',
  border: tokens.theme.border.structural.neutral,
  typography: 'P12R',
});

type ScanDateProps = {
  date?: string;
  format?: string;
  noBackground?: boolean;
  sx?: SxProps;
  tooltip?: Omit<TooltipProps, 'children'>;
};

export const ScanDate = ({
  date,
  format = 'MMMM D, HH:mm',
  sx,
  tooltip,
  noBackground,
}: ScanDateProps) => {
  const { palette } = useTheme();

  if (!date) {
    return null;
  }

  const formattedDate = dayjs(date).format(format);
  const icon = <Icons.ArrowsClockwise size={16} color={palette.grey[400]} />;

  return (
    <Value sx={mergeSx(sx, { bgcolor: noBackground ? undefined : 'grey.50' })}>
      {tooltip ? (
        <Tooltip arrow placement="top" {...tooltip}>
          {icon}
        </Tooltip>
      ) : (
        icon
      )}
      {formattedDate}
    </Value>
  );
};
